import Layout from '@/Layouts/Default'
import React from 'react'
import { LeftSection } from './components/LeftSection'
import { RightSection } from './components/RightSection'

export default function index() {
  return (
    <Layout>
      <div className='flex w-full h-full p-5 gap-0'>
        <div className='flex w-2/6 h-full'>
          <LeftSection />
        </div>
        <div className='flex w-4/6 h-full'>
          <RightSection />
        </div>
      </div>
    </Layout>
  )
}
